export default __webpack_public_path__ + "img/23.8bdc7b9d.jpg";